module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'documents',
        'document',
        'document',
    ],
    config: {
        documentType: 'offer'
    },
}